import 'jquery-ui';

$( "#datepicker" ).datepicker({
	showOtherMonths: true,
	selectOtherMonths: true,
	changeMonth: true,
	changeYear: true,
	dateFormat: "mm/dd/yy",
});
